/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import bookings_new_24x from "owa-appbar-icons/lib/bookings_new_24x.svg";
import Loop_color from "owa-appbar-icons/lib/Loop_color.png";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import Newsletters_22px from "owa-appbar-icons/lib/Newsletters_22px.svg";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import Newsletters_Mono_22px from "owa-appbar-icons/lib/Newsletters_Mono_22px.svg";
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import onedrive_24x from "owa-appbar-icons/lib/onedrive_24x.svg";
import onedrive_consumer_large from "owa-appbar-icons/lib/onedrive_consumer_large.png";
import onedrive_consumer_small from "owa-appbar-icons/lib/onedrive_consumer_small.png";
import onedrive_outline from "owa-appbar-icons/lib/onedrive_outline.png";
import todo_metaos from "owa-appbar-icons/lib/todo_metaos_32.png";
import vivaengage_clr_medium from "owa-appbar-icons/lib/vivaengage_clr_medium.png";
import vivaengage_clr_small from "owa-appbar-icons/lib/vivaengage_clr_small.png";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import loc from "owa-localize";
import { appAddison } from "owa-locstrings/lib/strings/appAddison.locstring.json";
import { getQueryStringParameter, hasQueryStringParameter } from "owa-querystring";
import { M365AppId } from "../M365AppId";
import { type AdditionalParameter, appendParametersToContentUrl } from "./utils";
import type { PlatformType, StrictTitle } from "../../types";
import type { MailboxInfo } from "owa-client-types";
import { EPOCH_TIME } from "../constants/constants";
import { EMPTY_COPILOT_CAPABILITIES } from "../constants/emptyCapability";
import { EMPTY_ELIGIBILITY } from "../constants/emptyEligibility";
import { getApplicationSettings } from "owa-application-settings";

const PRIMARY_COLOR = "#0078D4";

function isHttpsUrl(value: string): boolean {
    try {
        return new URL(value).protocol === "https:";
    }
    catch {
        return false;
    }
}

function withOutlookParams(contentUrl: string): string {
    const additionalParameters: AdditionalParameter[] = [
        ...["branch", "features", "appendbootflights", "removebootflights"].map(parameter => ({
            parameter,
            isEnabled: () => hasQueryStringParameter(parameter),
            getValue: () => encodeURIComponent(getQueryStringParameter(parameter)),
        })),
    ];
    
    return appendParametersToContentUrl(contentUrl, additionalParameters);
}

/*
 * Defines 1P apps that are MetaOs apps.
 * PS: Data is encoded to be displayed on the AppBar, declared on
 * owa-appbar-boostrap/../convertToM365ApplicationType.
 */
// TODO: What about `connectors`, `activities` and galleryTabs? Those are not defined in MOS3 schema.
const getVivaEngage = (): StrictTitle => ({
    __typename: "Title",
    
    ingestionId: M365AppId.VivaEngage,
    name: "Viva Engage",
    acquisitionDate: EPOCH_TIME,
    
    categories: ["m365_app" as PlatformType],
    longDescription: "Add a fully-interactive Viva Engage experience to Microsoft Teams. Viva Engage communities connect the organization, enabling you to engage with leaders, watch live events, and stay up-to-date with news and announcements. Communities also enable people to share knowledge, ask questions, get answers, and build relationships across teams and organizational silos. Add the Viva Engage app and pin it to the navigation rail. It\u2019s Viva Engage Teams.",
    shortDescription: "Drive engagement in your organization through Viva Engage communities.",
    iconSmall: {
        __typename: "M365AcquisitionIcon",
        uri: vivaengage_clr_small,
    },
    iconLarge: {
        __typename: "M365AcquisitionIcon",
        uri: vivaengage_clr_medium,
    },
    iconOutline: {
        __typename: "M365AcquisitionIcon",
        /* eslint-disable-next-line owa-custom-rules/forbid-hard-coded-cdn-urls -- (https://aka.ms/OWALintWiki)
         * BASELINE. DO NOT COPY AND PASTE!, replace this line with a justification or fix the error
         *	> Hard‑coding CDN URLs is generally discouraged because CDN endpoints vary across environments. Even when working within a single cloud, code should retrieve the current CDN URL dynamically rather than embedding a fixed value.
            For assets uploaded by Outlook Web — request paths beginning with /assets/, /nativehost/, /owamail/ — you can use getCdnUrl() from owa‑config to obtain the correct root CDN URL at runtime.
            To confirm that a resource exists, you can fetch it from the cloud‑specific endpoint. The list of endpoints is documented here:
            https://eng.ms/docs/experiences-devices/global-experiences-platform/outlook/outlook-web/m365-cdn/m365-shared-cdn/docs/onboarding/endpoints  (not all of them are publicly accessible). */
        uri: "https://statics.teams.cdn.office.net/evergreen-assets/apps/955070e9-99a6-4319-b8df-32adf59949aa_smallImage.png?v=2.1.1",
    },
    colorIconSmall: {
        __typename: "M365AcquisitionIcon",
        uri: vivaengage_clr_medium,
    },
    elementDefinitions: {
        __typename: "ElementDefinition",
        composeExtensions: [],
        exchangeAddIns: [],
        extensions: [],
        declarativeCopilots: [],
        customEngineCopilots: [],
        staticTabs: [
            {
                __typename: "LaunchPage",
                contentUrl: "https://web.yammer.com/teams/feed",
                entityId: "vivaengage",
                name: "Viva Engage",
                scopes: ["personal"],
                websiteUrl: "https://go.microsoft.com/fwlink/?linkid=2204694",
            },
        ],
    },
    accentColor: "#093c7f",
    isFullTrust: false,
    isFullScreen: true,
    developerName: "Microsoft Corporation",
    developerUrl: "https://www.microsoft.com/",
    devicePermissions: [],
    termsOfUseUrl: "https://aka.ms/yammer-teams-tos",
    permissions: [],
    validDomains: ["teams.yammer.com", "web.yammer.com", "www.yammer.com"],
    showLoadingIndicator: true,
    blockStatus: false,
    ingestionSource: "Hardcoded",
    scope: "Tenant",
    webApplicationInfo: {
        __typename: "WebApplicationInfo",
        id: "00000005-0000-0ff1-ce00-000000000000",
        resource: "https://web.yammer.com/teams",
    },
    version: "2.1.1", // NA
    cultureName: "en-US",
    manifestVersion: "1.13",
    authorization: {
        __typename: "AppAuthorization",
        permissions: {
            __typename: "AppPermissions",
            orgWide: [],
            resourceSpecific: [],
        },
    },
    copilotEnabled: false,
    copilotSettings: {
        __typename: "CopilotSettings",
        displayName: "",
        elementType: "Extension",
        capabilities: EMPTY_COPILOT_CAPABILITIES,
    },
    eligibility: EMPTY_ELIGIBILITY,
});

const getBookingsStrictTitle = (mailboxInfo?: MailboxInfo): StrictTitle => {
    const { domainURL, oauthResourceURL } = getApplicationSettings("BookingsDomainConfig", mailboxInfo);
    const domain = isHttpsUrl(domainURL) ? domainURL : "https://outlook.office.com";
    const oauthResource = isHttpsUrl(oauthResourceURL) ? oauthResourceURL : domain;
    const domainHostname = new URL(domain).hostname;
    const oauthResourceHostname = new URL(oauthResource).hostname;
    
    const BookingsVNextStrictTitle: StrictTitle = {
        __typename: "Title",
        
        ingestionId: M365AppId.Bookings,
        name: "Bookings",
        acquisitionDate: EPOCH_TIME,
        
        categories: ["m365_app" as PlatformType],
        longDescription: "Save time when scheduling with Microsoft Bookings. Customize appointment details, booking requirements, and specify service providers to streamline the booking experience for you and your customers. Bookings is integrated with your Microsoft 365 or Office 365 calendar to help your customers quickly find available times and avoid double-booking. With Bookings, you'll spend less time scheduling and more time meeting with customers.",
        shortDescription: "A simpler way to organize schedules and manage appointments.",
        iconSmall: {
            __typename: "M365AcquisitionIcon",
            uri: bookings_new_24x,
        },
        iconLarge: {
            __typename: "M365AcquisitionIcon",
            uri: bookings_new_24x,
        },
        iconOutline: {
            __typename: "M365AcquisitionIcon",
            uri: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgB7ZfhDYIwEIWvhP8yAiO4gWyiG+gIboBs4AaOgBuoG7iBblCPQM2FlN6RtqkxfMkFeFzKy3EtBWCBQWtd63jUSmBAQ0RyaaJC6LUxJtXHmLwMErMYyLguN4lTui/KdzDfJrTNgqtFW2MUEANpafHW0fWKpsbjmDSApyVG1R2JdgltwDULdhgtxo1oDxCiGEyeayV8YTwxGqJtx0m2KsyCKynJO+gZSJ/r6oFC931QEO3EPSikAdr11aCVoQ1Il+LVcAy+Fria8Az9ovTGpr0P2gaESKrwTXSVlOTttQVuPI7cMkA7krqylzCz/NJvgffHyNdA14QNJES8KV32hH9rIPmPiaQCMWdJ0hn4G3wARW+ykLoJvakAAAAASUVORK5CYII=",
        },
        colorIconSmall: {
            __typename: "M365AcquisitionIcon",
            uri: bookings_new_24x,
        },
        elementDefinitions: {
            __typename: "ElementDefinition",
            composeExtensions: [],
            exchangeAddIns: [],
            extensions: [],
            declarativeCopilots: [],
            customEngineCopilots: [],
            staticTabs: [
                {
                    __typename: "LaunchPage",
                    contentUrl: `${domain}/hosted/bookings/homepage/?hostApp=hub`,
                    entityId: "bookings",
                    name: "Home",
                    scopes: ["personal"],
                    websiteUrl: "",
                },
            ],
        },
        accentColor: "#007F9C",
        isFullTrust: false,
        isFullScreen: true,
        developerName: "Microsoft Corporation",
        developerUrl: "https://www.microsoft.com/",
        devicePermissions: [],
        termsOfUseUrl: "https://www.microsoft.com/servicesagreement",
        permissions: [],
        validDomains: [
            ...new Set([
                "*.office.com",
                "outlook.office.com",
                "outlook-sdf.office.com",
                "*.office365.com",
                "*.microsoft365.com",
                "*.office.net",
                "*.microsoft.com",
                "*.live.com",
                "outlook.live.com",
                "outlook-sdf.live.com",
                domainHostname,
                oauthResourceHostname,
            ]),
        ],
        blockStatus: false,
        ingestionSource: "Hardcoded",
        scope: "Tenant",
        webApplicationInfo: {
            __typename: "WebApplicationInfo",
            id: M365AppId.Bookings,
            resource: oauthResource,
        },
        version: "2.0.0",
        showLoadingIndicator: false,
        cultureName: "en-US",
        manifestVersion: "1.13",
        authorization: {
            __typename: "AppAuthorization",
            permissions: {
                __typename: "AppPermissions",
                orgWide: [],
                resourceSpecific: [],
            },
        },
        copilotEnabled: false,
        copilotSettings: {
            __typename: "CopilotSettings",
            displayName: "",
            elementType: "Extension",
            capabilities: EMPTY_COPILOT_CAPABILITIES,
        },
        eligibility: EMPTY_ELIGIBILITY,
    };
    
    return BookingsVNextStrictTitle;
};

/*
 * The To Do MetaOS App is hosted on the Outlook domain in each supported environement but
 * unlike sharepoint this is not a parameter that can be {substituted} in natively.
 * Using the outlookServiceDomain from application settings to construct the URL for the To Do
 * MetaOS App should work even in Vanity domain scenarios where the app will get popped out into a new tab.
 */
const getToDoMetaOs = (mailboxInfo?: MailboxInfo): StrictTitle => {
    const outlookServiceDomain = getApplicationSettings("OutlookServiceUrl", mailboxInfo).outlookServiceDomain;
    
    return {
        __typename: "Title",
        
        ingestionId: M365AppId.ToDoMetaOs,
        name: "To Do",
        acquisitionDate: EPOCH_TIME,
        
        categories: ["m365_app" as PlatformType],
        longDescription: "ToDo MetaOs App",
        shortDescription: "ToDo MetaOs App",
        iconSmall: {
            __typename: "M365AcquisitionIcon",
            uri: todo_metaos,
        },
        iconLarge: {
            __typename: "M365AcquisitionIcon",
            uri: todo_metaos,
        },
        iconOutline: {
            __typename: "M365AcquisitionIcon",
            /* eslint-disable-next-line owa-custom-rules/forbid-hard-coded-cdn-urls -- (https://aka.ms/OWALintWiki)
             * BASELINE. DO NOT COPY AND PASTE!, replace this line with a justification or fix the error
             *	> Hard‑coding CDN URLs is generally discouraged because CDN endpoints vary across environments. Even when working within a single cloud, code should retrieve the current CDN URL dynamically rather than embedding a fixed value.
            For assets uploaded by Outlook Web — request paths beginning with /assets/, /nativehost/, /owamail/ — you can use getCdnUrl() from owa‑config to obtain the correct root CDN URL at runtime.
            To confirm that a resource exists, you can fetch it from the cloud‑specific endpoint. The list of endpoints is documented here:
            https://eng.ms/docs/experiences-devices/global-experiences-platform/outlook/outlook-web/m365-cdn/m365-shared-cdn/docs/onboarding/endpoints  (not all of them are publicly accessible). */
            uri: "https://statics.teams.cdn.office.net/evergreen-assets/apps/0d5c91ee-5be2-4b79-81ed-23e6c4580427_smallImage.png?v=2",
        },
        colorIconSmall: {
            __typename: "M365AcquisitionIcon",
            uri: todo_metaos,
        },
        elementDefinitions: {
            __typename: "ElementDefinition",
            composeExtensions: [],
            exchangeAddIns: [],
            extensions: [],
            declarativeCopilots: [],
            customEngineCopilots: [],
            staticTabs: [
                {
                    __typename: "LaunchPage",
                    websiteUrl: "",
                    contentUrl: `https://${outlookServiceDomain}/tasks?app&hostApp=metaOSHub`,
                    entityId: "ToDoId",
                    name: "To Do",
                    scopes: ["personal"],
                },
            ],
        },
        accentColor: PRIMARY_COLOR,
        isFullTrust: false,
        isFullScreen: true,
        developerName: "Microsoft Corporation",
        developerUrl: "https://www.microsoft.com/",
        devicePermissions: [],
        termsOfUseUrl: "https://www.microsoft.com/servicesagreement",
        permissions: [],
        validDomains: [
            "outlook.live.com",
            "*.live.com",
            "outlook.office.com",
            "*.office.com",
            "*.microsoft.com",
        ],
        showLoadingIndicator: false,
        blockStatus: false,
        ingestionSource: "Hardcoded",
        scope: "Tenant",
        webApplicationInfo: {
            __typename: "WebApplicationInfo",
            id: M365AppId.ToDoMetaOs,
            resource: `https://${outlookServiceDomain}/`,
        },
        version: "0.0.0", // NA
        cultureName: "en-US",
        manifestVersion: "1.13",
        authorization: {
            __typename: "AppAuthorization",
            permissions: {
                __typename: "AppPermissions",
                orgWide: [],
                resourceSpecific: [],
            },
        },
        copilotEnabled: false,
        copilotSettings: {
            __typename: "CopilotSettings",
            displayName: "",
            elementType: "Extension",
            capabilities: EMPTY_COPILOT_CAPABILITIES,
        },
        eligibility: EMPTY_ELIGIBILITY,
    };
};

const Hoop: StrictTitle = {
    __typename: "Title",
    
    ingestionId: M365AppId.Hoop,
    name: "Loop",
    acquisitionDate: EPOCH_TIME,
    
    categories: ["m365_app" as PlatformType],
    longDescription: "Microsoft Loop is a transformative co-creation experience that brings together teams, content and tasks across your tools and devices. Loop combines a powerful and flexible canvas with portable components that move freely and stay in sync across applications \u2014 enabling teams to think, plan, and create together",
    shortDescription: "Think, plan and create together with Microsoft Loop",
    
    iconSmall: {
        __typename: "M365AcquisitionIcon",
        uri: Loop_color,
    },
    iconLarge: {
        __typename: "M365AcquisitionIcon",
        uri: Loop_color,
    },
    iconOutline: {
        __typename: "M365AcquisitionIcon",
        /* eslint-disable-next-line owa-custom-rules/forbid-hard-coded-cdn-urls -- (https://aka.ms/OWALintWiki)
         * BASELINE. DO NOT COPY AND PASTE!, replace this line with a justification or fix the error
         *	> Hard‑coding CDN URLs is generally discouraged because CDN endpoints vary across environments. Even when working within a single cloud, code should retrieve the current CDN URL dynamically rather than embedding a fixed value.
            For assets uploaded by Outlook Web — request paths beginning with /assets/, /nativehost/, /owamail/ — you can use getCdnUrl() from owa‑config to obtain the correct root CDN URL at runtime.
            To confirm that a resource exists, you can fetch it from the cloud‑specific endpoint. The list of endpoints is documented here:
            https://eng.ms/docs/experiences-devices/global-experiences-platform/outlook/outlook-web/m365-cdn/m365-shared-cdn/docs/onboarding/endpoints  (not all of them are publicly accessible). */
        uri: "https://statics.teams.cdn.office.net/app-assets/ring1/4a6520d6-94a8-4730-9184-24997b9b3401/4a6520d6-94a8-4730-9184-24997b9b3401_smallImage.png?v=1.0.1",
    },
    colorIconSmall: {
        __typename: "M365AcquisitionIcon",
        uri: Loop_color,
    },
    elementDefinitions: {
        __typename: "ElementDefinition",
        composeExtensions: [],
        exchangeAddIns: [],
        extensions: [],
        declarativeCopilots: [],
        customEngineCopilots: [],
        staticTabs: [
            {
                __typename: "LaunchPage",
                entityId: "auth",
                name: "Loop",
                contentUrl: "https://hosted.loop.cloud.microsoft?metaosHost=Outlook&frameworkLayout=true",
                websiteUrl: "",
                scopes: ["personal"],
            },
        ],
    },
    accentColor: "#8230FF",
    isFullTrust: false,
    isFullScreen: true,
    developerName: "Microsoft Corporation",
    developerUrl: "https://www.microsoft.com/",
    devicePermissions: [],
    termsOfUseUrl: "https://www.microsoft.com/termsofuse",
    permissions: ["identity", "messageTeamMembers"],
    validDomains: [
        "outlook.live.com",
        "*.live.com",
        "outlook.office.com",
        "*.office.com",
        "*.microsoft.com",
        "outlook-sdf.office.com",
        "substrate.office.com",
        "graph.microsoft.com",
        "loop.microsoft.com",
        "*.loop.microsoft.com",
        "*.blob.core.windows.net",
        "outlook-sdf.office365.com",
        "clients.config.office.net",
        "browser.events.data.microsoft.com",
        "officefluidprdeployments.azurewebsites.net",
        "hosted.loop.cloud.microsoft.com",
    ],
    showLoadingIndicator: true,
    blockStatus: false,
    ingestionSource: "Hardcoded",
    scope: "Tenant",
    webApplicationInfo: {
        __typename: "WebApplicationInfo",
        id: M365AppId.Hoop,
        resource: "https://hosted.loop.cloud.microsoft",
    },
    version: "1.0.0", // NA
    cultureName: "en-US",
    manifestVersion: "1.14",
    authorization: {
        __typename: "AppAuthorization",
        permissions: {
            __typename: "AppPermissions",
            orgWide: [],
            resourceSpecific: [],
        },
    },
    copilotEnabled: false,
    copilotSettings: {
        __typename: "CopilotSettings",
        displayName: "",
        elementType: "Extension",
        capabilities: EMPTY_COPILOT_CAPABILITIES,
    },
    eligibility: EMPTY_ELIGIBILITY,
};

const OneDriveMetaOs: StrictTitle = {
    __typename: "Title",
    
    ingestionId: M365AppId.OneDriveMetaOs,
    name: "OneDrive",
    acquisitionDate: EPOCH_TIME,
    
    categories: ["m365_app" as PlatformType],
    shortDescription: "Official OneDrive app for Microsoft 365",
    longDescription: "",
    iconSmall: {
        __typename: "M365AcquisitionIcon",
        uri: onedrive_24x,
    },
    iconLarge: {
        __typename: "M365AcquisitionIcon",
        uri: onedrive_24x,
    },
    iconOutline: {
        __typename: "M365AcquisitionIcon",
        uri: onedrive_outline,
    },
    colorIconSmall: {
        __typename: "M365AcquisitionIcon",
        uri: onedrive_24x,
    },
    elementDefinitions: {
        __typename: "ElementDefinition",
        composeExtensions: [],
        exchangeAddIns: [],
        extensions: [],
        declarativeCopilots: [],
        customEngineCopilots: [],
        staticTabs: [
            {
                __typename: "LaunchPage",
                entityId: "7211f19f-262a-42eb-a02e-289956491741",
                name: "OneDrive",
                contentUrl: "https://{mySiteDomain}{mySitePath}/_layouts/15/filebrowser.aspx?app=MetaOS&fileBrowser={\"sdk\":\"8.0\",\"entry\":{\"oneDrive\":{}},\"metaOS\":{\"host\":\"{hostName}\"},\"theme\":\"{theme}\",\"telemetry\":{\"ring\":\"{ringId}\",\"correlationId\":\"{appSessionId}\"}}&scenario=OneDrive&auth=none&locale={locale}",
                websiteUrl: "https://go.microsoft.com/fwlink/?linkid=2225080",
                scopes: ["personal"],
            },
        ],
    },
    accentColor: "#FFFFFF",
    isFullTrust: false,
    isFullScreen: true,
    developerName: "Microsoft Corp",
    developerUrl: "https://www.microsoft.com/",
    devicePermissions: [],
    termsOfUseUrl: "https://www.microsoft.com/servicesagreement",
    permissions: ["identity", "messageTeamMembers"],
    validDomains: [
        "{mySiteDomain}{mySitePath}",
        "go.microsoft.com",
        "{mySiteDomain}",
        "*.sharepoint.com",
        "*.login.microsoftonline.com",
    ],
    showLoadingIndicator: false,
    blockStatus: false,
    ingestionSource: "Hardcoded",
    scope: "Tenant",
    webApplicationInfo: {
        __typename: "WebApplicationInfo",
        id: "00000003-0000-0ff1-ce00-000000000000",
        resource: "https://{mySiteDomain}",
    },
    version: "1.0.0", // NA
    cultureName: "EN-US",
    manifestVersion: "m365DevPreview",
    authorization: {
        __typename: "AppAuthorization",
        permissions: {
            __typename: "AppPermissions",
            orgWide: [],
            resourceSpecific: [],
        },
    },
    copilotEnabled: false,
    copilotSettings: {
        __typename: "CopilotSettings",
        displayName: "",
        elementType: "Extension",
        capabilities: EMPTY_COPILOT_CAPABILITIES,
    },
    eligibility: EMPTY_ELIGIBILITY,
};

const OneDriveConsumerMetaOs: StrictTitle = {
    __typename: "Title",
    
    ingestionId: M365AppId.OneDriveConsumerMetaOs,
    name: "OneDrive",
    acquisitionDate: EPOCH_TIME,
    
    categories: ["m365_app" as PlatformType],
    shortDescription: "Official OneDrive app",
    longDescription: "Easily store, access, and discover your individual and shared files.",
    iconSmall: {
        __typename: "M365AcquisitionIcon",
        uri: onedrive_consumer_small,
    },
    iconLarge: {
        __typename: "M365AcquisitionIcon",
        uri: onedrive_consumer_large,
    },
    iconOutline: {
        __typename: "M365AcquisitionIcon",
        uri: onedrive_outline,
    },
    colorIconSmall: {
        __typename: "M365AcquisitionIcon",
        uri: onedrive_consumer_small,
    },
    elementDefinitions: {
        __typename: "ElementDefinition",
        composeExtensions: [],
        exchangeAddIns: [],
        extensions: [],
        declarativeCopilots: [],
        customEngineCopilots: [],
        staticTabs: [
            {
                __typename: "LaunchPage",
                entityId: "8a688e1a-af75-4af8-801c-2c7f76dfb6cf",
                name: "OneDrive",
                contentUrl: "https://onedrive.live.com/browser?app=MetaOS&fileBrowser={\"sdk\":\"8.0\",\"entry\":{\"oneDrive\":{}},\"metaOS\":{\"host\":\"{hostName}\"},\"theme\":\"{theme}\",\"telemetry\":{\"ring\":\"{ringId}\",\"correlationId\":\"{appSessionId}\"}}&scenario=OneDrive&auth=none&smkt={locale}",
                websiteUrl: "https://onedrive.live.com",
                scopes: ["personal"],
            },
            {
                __typename: "LaunchPage",
                entityId: "about",
                name: "",
                contentUrl: "",
                websiteUrl: "",
                scopes: ["personal"],
            },
        ],
    },
    accentColor: "#FFFFFF",
    isFullTrust: false,
    isFullScreen: true,
    developerName: "Microsoft",
    developerUrl: "https://www.microsoft.com/",
    devicePermissions: [],
    termsOfUseUrl: "https://www.microsoft.com/en-us/legal/terms-of-use",
    permissions: ["identity", "messageTeamMembers"],
    validDomains: ["onedrive.live.com", "login.live.com", "api.onedrive.com"],
    showLoadingIndicator: false,
    blockStatus: false,
    ingestionSource: "Hardcoded",
    scope: "Tenant",
    webApplicationInfo: {
        __typename: "WebApplicationInfo",
        id: "865367a6-9c28-4844-88ce-259d34dbabae",
        resource: "api://onedrive.live.com",
    },
    version: "1.0.0", // NA
    cultureName: "EN-US",
    manifestVersion: "m365DevPreview",
    authorization: {
        __typename: "AppAuthorization",
        permissions: {
            __typename: "AppPermissions",
            orgWide: [],
            resourceSpecific: [],
        },
    },
    copilotEnabled: false,
    copilotSettings: {
        __typename: "CopilotSettings",
        displayName: "",
        elementType: "Extension",
        capabilities: EMPTY_COPILOT_CAPABILITIES,
    },
    eligibility: EMPTY_ELIGIBILITY,
};

const getNewsletters = (_mailboxInfo?: MailboxInfo): StrictTitle => ({
    __typename: "Title",
    
    ingestionId: M365AppId.Newsletters,
    name: loc(appAddison) || "Newsletters",
    acquisitionDate: EPOCH_TIME,
    
    categories: ["m365_app" as PlatformType],
    longDescription: "",
    shortDescription: "",
    iconSmall: {
        __typename: "M365AcquisitionIcon",
        uri: Newsletters_22px,
    },
    iconLarge: {
        __typename: "M365AcquisitionIcon",
        uri: Newsletters_22px,
    },
    iconOutline: {
        __typename: "M365AcquisitionIcon",
        uri: Newsletters_Mono_22px,
    },
    colorIconSmall: {
        __typename: "M365AcquisitionIcon",
        uri: Newsletters_22px,
    },
    elementDefinitions: {
        __typename: "ElementDefinition",
        composeExtensions: [],
        exchangeAddIns: [],
        extensions: [],
        declarativeCopilots: [],
        customEngineCopilots: [],
        staticTabs: [
            {
                __typename: "LaunchPage",
                entityId: "home",
                name: "Newsletters",
                contentUrl: withOutlookParams(`https://outlook.office.com/hosted/OID:{user.id}@{user.tenant.id}/newsletters?hostApp=hub&isanonymous=true&culture={locale}${isGlobalFeatureEnabled("mos-newslettersApp-gulp") ? "&ori" : ""}`),
                websiteUrl: "",
                scopes: ["personal"],
            },
            {
                __typename: "LaunchPage",
                entityId: "selectTemplate",
                name: "Create Newsletter",
                contentUrl: withOutlookParams(`https://outlook.office.com/hosted/OID:{user.id}@{user.tenant.id}/newsletters?hostApp=hub&isanonymous=true&culture={locale}${isGlobalFeatureEnabled("mos-newslettersApp-gulp") ? "&ori" : ""}`),
                websiteUrl: "",
                scopes: ["personal"],
            },
        ],
    },
    accentColor: "#60A18E",
    isFullTrust: true,
    isFullScreen: true,
    developerName: "Microsoft Corporation",
    developerUrl: "https://www.microsoft.com/",
    devicePermissions: [],
    termsOfUseUrl: "https://www.microsoft.com/servicesagreement",
    permissions: [],
    validDomains: [
        "outlook.office.com",
        "*.office.com",
        "*.microsoft.com",
        "outlook-sdf.office.com",
    ],
    showLoadingIndicator: false,
    blockStatus: false,
    ingestionSource: "Hardcoded",
    scope: "Tenant",
    webApplicationInfo: {
        __typename: "WebApplicationInfo",
        id: M365AppId.Newsletters,
        resource: `https://outlook.office.com/`,
    },
    version: "1.0.1",
    cultureName: "en-US",
    manifestVersion: "1.14",
    authorization: {
        __typename: "AppAuthorization",
        permissions: {
            __typename: "AppPermissions",
            orgWide: [],
            resourceSpecific: [],
        },
    },
    copilotEnabled: false,
    copilotSettings: {
        __typename: "CopilotSettings",
        displayName: "",
        elementType: "Extension",
        capabilities: EMPTY_COPILOT_CAPABILITIES,
    },
    eligibility: EMPTY_ELIGIBILITY,
});

const getLaunchPageTitles = (mailboxInfo?: MailboxInfo): StrictTitle[] => {
    return [
        getBookingsStrictTitle(mailboxInfo),
        getToDoMetaOs(mailboxInfo),
        getVivaEngage(),
        Hoop,
        OneDriveMetaOs,
        OneDriveConsumerMetaOs,
        getNewsletters(mailboxInfo),
    ];
};

export { getLaunchPageTitles };
